import { Button, Popover, Typography } from "antd";
import Label from "components/Label";
import { InfoCircleTwoTone } from "@ant-design/icons";
// import CONTROL_RISK_VALUES from 'ressources/data/controlRiskValues.json';

export default function EffectInfo({ effect }) {

	// const effectValue = CONTROL_RISK_VALUES[effect]; // Disabled, but the JSON is stil in data/controlRiskValue.json

	const content = (
		<div className="effect-info">
			<Typography.Paragraph>
				<Label id={"graph.effect.info.description." + effect} />
			</Typography.Paragraph>
		</div>
	)

	return (
		<Popover placement="bottom" content={content} trigger="click">
			<Button className="effect-info-button" type="text" size="large" style={{ fontSize: 18, fontWeight: 450 }}>
				<span><Label id={effect} /></span><InfoCircleTwoTone />
			</Button>
		</Popover>
	)
}